<template>
  <el-row>
    <el-col :xs="24">
      <el-card>
        <div slot="header" class="clearfix">
          <span class="cadastro-title">Pergunta Grupo</span>
        </div>
        <div id="content" class="ui basic segment" v-loading="isLoading">
          <data-tables :data="list" :table-props="tableProps" :actions-def="actionsDef">
            <el-table-column v-for="title in titles" :prop="title.prop"
                             :label="title.label"
                             :key="title.label"
                             :width="title.width">
            </el-table-column>

            <el-table-column label="Ações" min-width="100px">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button size="mini" type="primary">
                    Ações<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <router-link :to="{ name: 'perguntagrupo.show', params: { grupo: scope.row.id  }}">
                      <el-dropdown-item><i class="icon-eye"></i> Visualizar</el-dropdown-item>
                    </router-link>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: "pergunta-index",
    data() {
      return {
        isLoading: false,
        actionsDef: {
          colProps: {
            span: 19
          },
          def: [{
            name: 'Novo',
            handler: () => {
              this.$router.push({name: 'perguntagrupo.create'})
            }
          }]
        },
        titles: [
          {prop: 'id', label: '#', width: 50},
          {prop: 'nome', label: 'Nome', width: 500}
        ],
        tableProps: {
          border: false,
          stripe: true
        }
      }
    },
    computed: {
      ...mapState('PerguntaGrupo', ['list'])
    },
    methods: {
      ...mapActions('PerguntaGrupo', ['setList']),
      async load() {
        try {
          this.isLoading = true
          await this.setList()
        } catch (e) {
          console.log(e)
        } finally {
          this.isLoading = false
        }
      }
    },
    async mounted() {
      await  this.load()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/PerguntaGrupo/Index.vue